import Text from '~/core/Text'

type NavTitlePropsType = {
    title: string
    marginTop?: string
    marginLeft?: string
}

export default function NavTitle({
    title,
    marginTop = '4px',
    marginLeft = '0px',
}: NavTitlePropsType) {
    return (
        <Text
            fontWeight={500}
            fontSize="16px"
            style={{
                marginTop,
                marginLeft,
            }}
        >
            {title}
        </Text>
    )
}
